import React, { useState,useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "./Card";
import { Button, TextField } from "@material-ui/core";
import { useWallet } from '../../context/walletProvider'
function NftContainer({ handleApprove }) {
  const [tokens,setTokens] = useState([]);
  const wallet = useWallet()
  useEffect(() => {      
      setTokens(wallet.userTokens)
  }, [wallet])
  return (
    <div className='nft-box-container2'>
      <h1
        style={{
          color: "#CDCDCD",
          fontSize: "20px",
          textAlign: "center",
          width: "32%",
        }}
        //onClick={() => {this.props}}
      >
        Select NFTs
      </h1>

      <Grid
        container
        style={{ alignItems: "center", margin: "auto", width: "80%" }}
      >
        {tokens.map((token) => {
          if(token.status==0){
          return (
            <Grid item xs={12} sm={4}>
              <Card
                header={token.tokenId}
                imageUrl={token.imageUrl}
                message={token.tokenAddress}
                isApproved={token.isApproved}
                handleApprove={handleApprove}
                buttonMessage='Approve'
              />
            </Grid>
          );
          }
        })}
      </Grid>
    </div>
  );
}

export default NftContainer;
